import styled from 'styled-components'

export const Label = styled('span')`
  font-family: Hind Vadodara;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  flex: none;
`

